import { Link } from "react-router-dom";
import { GraduationCap, Mail, MapPin, Linkedin, Twitter, Youtube } from "lucide-react";

const COLS = [
    { title: "Learn", links: [["Programs", "/programs"], ["Learning Paths", "/learning-paths"], ["Resources", "/resources"], ["Verify a Credential", "/verify"]] },
    { title: "For Organizations", links: [["For Schools", "/for-schools"], ["Corporate Academy", "/corporate"], ["Community Mission", "/community"]] },
    { title: "Account", links: [["Log in", "/login"], ["Get Started", "/register"], ["Student Dashboard", "/dashboard"]] },
];

export default function Footer() {
    return (
        <footer className="bg-secondary text-secondary-foreground" data-testid="footer">
            <div className="container-page py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
                <div className="lg:col-span-2">
                    <Link to="/" className="flex items-center gap-2">
                        <span className="grid h-9 w-9 place-items-center rounded-lg bg-primary text-primary-foreground">
                            <GraduationCap className="h-5 w-5" />
                        </span>
                        <span className="font-heading text-lg font-extrabold">LARUTA<span className="text-primary">.</span></span>
                    </Link>
                    <p className="mt-4 max-w-sm text-sm text-secondary-foreground/70 leading-relaxed">
                        Practical Digital & AI Education for Every Generation. Learn → Practice → Create → Demonstrate → Progress.
                    </p>
                    <div className="mt-5 space-y-2 text-sm text-secondary-foreground/70">
                        <p className="flex items-center gap-2"><Mail className="h-4 w-4" /> hello@larutainternational.com</p>
                        <p className="flex items-center gap-2"><MapPin className="h-4 w-4" /> LARUTA International Pvt. Ltd.</p>
                    </div>
                    <div className="mt-5 flex gap-3">
                        {[Linkedin, Twitter, Youtube].map((I, i) => (
                            <a key={i} href="#" className="grid h-9 w-9 place-items-center rounded-full bg-white/10 hover:bg-primary transition-colors">
                                <I className="h-4 w-4" />
                            </a>
                        ))}
                    </div>
                </div>
                {COLS.map((c) => (
                    <div key={c.title}>
                        <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-secondary-foreground/50">{c.title}</h4>
                        <ul className="mt-4 space-y-2.5">
                            {c.links.map(([label, to]) => (
                                <li key={label}>
                                    <Link to={to} className="text-sm text-secondary-foreground/80 hover:text-primary transition-colors">{label}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
            <div className="border-t border-white/10">
                <div className="container-page py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-secondary-foreground/50">
                    <p>© {new Date().getFullYear()} LARUTA International Private Limited. All rights reserved.</p>
                    <p className="font-mono">Experience &gt; Certificate</p>
                </div>
            </div>
        </footer>
    );
}
